module.exports = __webpack_public_path__ + "img/graph-dummy-sm.1a02c17d.svg";